// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useHistory, useLocation } from "react-router-dom";
// import { useSnackbar } from "react-simple-snackbar";
// import { makeStyles } from "@material-ui/core/styles";
// import {
//   Container,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Paper,
//   TableContainer,
//   Box,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@material-ui/core";
// import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// import { updateItems } from "../../actions/itemActions";
// import { getAllCategories } from "../../actions/categoryActions";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     padding: theme.spacing(3),
//     maxWidth: 1200,
//   },
//   header: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginBottom: theme.spacing(3),
//   },
//   tableContainer: {
//     marginTop: theme.spacing(2),
//     maxHeight: "60vh",
//     borderRadius: theme.shape.borderRadius,
//     boxShadow: theme.shadows[2],
//   },
//   backButton: {
//     borderRadius: 20,
//   },
//   button: {
//     margin: theme.spacing(1),
//     borderRadius: 20,
//     padding: theme.spacing(1, 3),
//     textTransform: "none",
//   },
//   textField: {
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": {
//         borderColor: "#ddd",
//       },
//       "&:hover fieldset": {
//         borderColor: "#ef7f1a",
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: "#ef7f1a",
//       },
//     },
//   },
//   formControl: {
//     minWidth: 200,
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": {
//         borderColor: "#ddd",
//       },
//       "&:hover fieldset": {
//         borderColor: "#ef7f1a",
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: "#ef7f1a",
//       },
//     },
//   },
//   errorText: {
//     color: theme.palette.error.main,
//     fontSize: "0.875rem",
//   },
// }));

// const BulkItemEdit = () => {
//   const classes = useStyles();
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const location = useLocation();
//   const { categories } = useSelector((state) => state.categories);
//   const [openSnackbar] = useSnackbar();
//   const selectedItems = location.state?.selectedItems || [];

//   // Initialize editData with selected items' current values
//   const [editData, setEditData] = useState(
//     selectedItems.map((item) => ({
//       _id: item._id,
//       itemName: item.itemName,
//       salePrice: item.units.sale.price?.toString() || "",
//       categoryId: item.category?.categoryId || "",
//       errors: { salePrice: "" },
//     }))
//   );

//   useEffect(() => {
//     dispatch(getAllCategories());
//   }, [dispatch]);

//   const validateForm = () => {
//     let isValid = true;
//     const updatedEditData = editData.map((item) => {
//       const errors = { salePrice: "" };
//       if (item.salePrice && isNaN(Number(item.salePrice))) {
//         errors.salePrice = "Price must be a valid number";
//         isValid = false;
//       }
//       if (item.salePrice && Number(item.salePrice) < 0) {
//         errors.salePrice = "Price cannot be negative";
//         isValid = false;
//       }
//       return { ...item, errors };
//     });
//     setEditData(updatedEditData);
//     return isValid;
//   };

//   const handleChange = (index, field, value) => {
//     setEditData((prev) =>
//       prev.map((item, i) =>
//         i === index
//           ? {
//               ...item,
//               [field]: value,
//               errors: { ...item.errors, [field]: "" }, // Clear error on change
//             }
//           : item
//       )
//     );
//   };

//   const handleSubmit = async () => {
//     if (!validateForm()) {
//       openSnackbar("Please correct the errors before submitting");
//       return;
//     }

//     // Check if at least one item has a change
//     const hasChanges = editData.some(
//       (item, index) =>
//         item.salePrice !== (selectedItems[index].units.sale.price?.toString() || "") ||
//         item.categoryId !== (selectedItems[index].category?.categoryId || "")
//     );

//     if (!hasChanges) {
//       openSnackbar("No changes were made to any items");
//       return;
//     }

//     const updatedItems = editData.map((item, index) => ({
//       _id: item._id,
//       units: {
//         ...selectedItems[index].units,
//         sale: {
//           ...selectedItems[index].units.sale,
//           price: item.salePrice ? Number(item.salePrice) : selectedItems[index].units.sale.price,
//         },
//       },
//       category: item.categoryId
//         ? {
//             categoryId: item.categoryId,
//             categoryName: categories.find((c) => c._id === item.categoryId)?.categoryName || "",
//           }
//         : selectedItems[index].category,
//     }));

//     try {
//       await dispatch(updateItems(updatedItems, openSnackbar));
//       history.push("/ItemsList");
//     } catch (error) {
//       console.error("Error updating items in BulkItemEdit:", error);
//     }
//   };

//   const handleBack = () => {
//     history.push("/ItemsList");
//   };

//   return (
//     <Container className={classes.container}>
//       <Box className={classes.header}>
//         <Button
//           variant="outlined"
//           color="primary"
//           startIcon={<ArrowBackIcon />}
//           onClick={handleBack}
//           className={classes.backButton}
//         >
//           Back to ItemList
//         </Button>
//         <Typography variant="h4">Bulk Item Edit</Typography>
//         <div style={{ width: 100 }} />
//       </Box>

//       {selectedItems.length === 0 ? (
//         <Typography variant="h6" color="textSecondary" align="center">
//           No items selected. Please select items from the Items List.
//         </Typography>
//       ) : (
//         <>
//           <TableContainer component={Paper} className={classes.tableContainer}>
//             <Table stickyHeader size="small">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>S.No</TableCell>
//                   <TableCell>Name</TableCell>
//                   <TableCell>Sale Price</TableCell>
//                   <TableCell>Category</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {editData.map((item, index) => (
//                   <TableRow key={item._id}>
//                     <TableCell>{index + 1}</TableCell>
//                     <TableCell>{item.itemName}</TableCell>
//                     <TableCell>
//                       <TextField
//                         variant="outlined"
//                         type="number"
//                         value={item.salePrice}
//                         onChange={(e) => handleChange(index, "salePrice", e.target.value)}
//                         size="small"
//                         className={classes.textField}
//                         error={!!item.errors.salePrice}
//                         helperText={item.errors.salePrice}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <FormControl variant="outlined" className={classes.formControl} size="small">
//                         <InputLabel id={`category-label-${index}`}>Category</InputLabel>
//                         <Select
//                           labelId={`category-label-${index}`}
//                           value={item.categoryId}
//                           onChange={(e) => handleChange(index, "categoryId", e.target.value)}
//                           label="Category"
//                         >
//                           <MenuItem value="">
//                             <em>No Category</em>
//                           </MenuItem>
//                           {categories
//                             .filter((c) => c.isActive)
//                             .map((category) => (
//                               <MenuItem key={category._id} value={category._id}>
//                                 {category.categoryName}
//                               </MenuItem>
//                             ))}
//                         </Select>
//                       </FormControl>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <Box display="flex" justifyContent="flex-end" mt={2}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleSubmit}
//               className={classes.button}
//             >
//               Apply Changes
//             </Button>
//           </Box>
//         </>
//       )}
//     </Container>
//   );
// };

// export default BulkItemEdit;
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useSnackbar } from "react-simple-snackbar";
import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { updateItems } from "../../actions/itemActions";
import { getAllCategories } from "../../actions/categoryActions";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    maxWidth: 1200,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(3),
  },
  tableContainer: {
    marginTop: theme.spacing(2),
    maxHeight: "60vh",
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
  },
  backButton: {
    borderRadius: 20,
  },
  button: {
    margin: theme.spacing(1),
    borderRadius: 20,
    padding: theme.spacing(1, 3),
    textTransform: "none",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ddd",
      },
      "&:hover fieldset": {
        borderColor: "#ef7f1a",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ef7f1a",
      },
    },
  },
  formControl: {
    minWidth: 200,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ddd",
      },
      "&:hover fieldset": {
        borderColor: "#ef7f1a",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ef7f1a",
      },
    },
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: "0.875rem",
  },
  moveToCategoryContainer: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
}));

const BulkItemEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { categories } = useSelector((state) => state.categories);
  const [openSnackbar] = useSnackbar();
  const selectedItems = location.state?.selectedItems || [];

  // Initialize editData with selected items' current values
  const [editData, setEditData] = useState(
    selectedItems.map((item) => ({
      _id: item._id,
      itemName: item.itemName,
      salePrice: item.units.sale.price?.toString() || "",
      categoryId: item.category?.categoryId || "",
      errors: { salePrice: "" },
    }))
  );
  // State for the "Move to Category" dropdown
  const [moveToCategoryId, setMoveToCategoryId] = useState("");

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const validateForm = () => {
    let isValid = true;
    const updatedEditData = editData.map((item) => {
      const errors = { salePrice: "" };
      if (item.salePrice && isNaN(Number(item.salePrice))) {
        errors.salePrice = "Price must be a valid number";
        isValid = false;
      }
      if (item.salePrice && Number(item.salePrice) < 0) {
        errors.salePrice = "Price cannot be negative";
        isValid = false;
      }
      return { ...item, errors };
    });
    setEditData(updatedEditData);
    return isValid;
  };

  const handleChange = (index, field, value) => {
    setEditData((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              [field]: value,
              errors: { ...item.errors, [field]: "" }, // Clear error on change
            }
          : item
      )
    );
  };

  // New function to handle moving all items to a selected category
  const handleMoveToCategory = () => {
    if (!moveToCategoryId) {
      openSnackbar("Please select a category to move items to");
      return;
    }

    setEditData((prev) =>
      prev.map((item) => ({
        ...item,
        categoryId: moveToCategoryId,
      }))
    );
    openSnackbar("Items moved to selected category");
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      openSnackbar("Please correct the errors before submitting");
      return;
    }
  
    // Check if at least one item has a change
    const hasChanges = editData.some(
      (item, index) =>
        item.salePrice !== (selectedItems[index].units.sale.price?.toString() || "") ||
        item.categoryId !== (selectedItems[index].category?.categoryId || "")
    );
  
    if (!hasChanges) {
      openSnackbar("No changes were made to any items");
      return;
    }
  
    const updatedItems = editData.map((item, index) => ({
      _id: item._id,
      units: {
        ...selectedItems[index].units,
        sale: {
          ...selectedItems[index].units.sale,
          price: item.salePrice ? Number(item.salePrice) : selectedItems[index].units.sale.price,
        },
      },
      category: item.categoryId
        ? {
            categoryId: item.categoryId,
            categoryName: categories.find((c) => c._id === item.categoryId)?.categoryName || "",
          }
        : selectedItems[index].category,
      stockQty: selectedItems[index].stockQty, // Preserve the entire stockQty object
      vat: selectedItems[index].vat, // Preserve vat
    }));
  
    try {
      await dispatch(updateItems(updatedItems, openSnackbar));
      history.push("/ItemsList");
    } catch (error) {
      console.error("Error updating items in BulkItemEdit:", error);
    }
  };

  const handleBack = () => {
    history.push("/ItemsList");
  };

  return (
    <Container className={classes.container}>
      <Box className={classes.header}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          className={classes.backButton}
        >
          Back to ItemList
        </Button>
        <Typography variant="h4">Bulk Item Edit</Typography>
        <div style={{ width: 100 }} />
      </Box>

      {selectedItems.length === 0 ? (
        <Typography variant="h6" color="textSecondary" align="center">
          No items selected. Please select items from the Items List.
        </Typography>
      ) : (
        <>
          {/* New "Move to Category" Section */}
          <Box className={classes.moveToCategoryContainer}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="move-to-category-label">Select the category</InputLabel>
              <Select
                labelId="move-to-category-label"
                value={moveToCategoryId}
                onChange={(e) => setMoveToCategoryId(e.target.value)}
                label="Move to Category"
              >
                <MenuItem value="">
                  <em>Select Category</em>
                </MenuItem>
                {categories
                  .filter((c) => c.isActive)
                  .map((category) => (
                    <MenuItem key={category._id} value={category._id}>
                      {category.categoryName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              color="primary"
              onClick={handleMoveToCategory}
              className={classes.button}
            >
              Move Selected Items to Category
            </Button>
          </Box>

          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Sale Price</TableCell>
                  <TableCell>Category</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {editData.map((item, index) => (
                  <TableRow key={item._id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.itemName}</TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        type="number"
                        value={item.salePrice}
                        onChange={(e) => handleChange(index, "salePrice", e.target.value)}
                        size="small"
                        className={classes.textField}
                        error={!!item.errors.salePrice}
                        helperText={item.errors.salePrice}
                      />
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" className={classes.formControl} size="small">
                        <InputLabel id={`category-label-${index}`}>Category</InputLabel>
                        <Select
                          labelId={`category-label-${index}`}
                          value={item.categoryId}
                          onChange={(e) => handleChange(index, "categoryId", e.target.value)}
                          label="Category"
                        >
                          <MenuItem value="">
                            <em>No Category</em>
                          </MenuItem>
                          {categories
                            .filter((c) => c.isActive)
                            .map((category) => (
                              <MenuItem key={category._id} value={category._id}>
                                {category.categoryName}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              className={classes.button}
            >
              Apply Changes
            </Button>
          </Box>
        </>
      )}
    </Container>
  );
};

export default BulkItemEdit;